module.exports = __webpack_public_path__ + "static/media/detinate.ccb68b18.svg";